import { writable } from 'svelte/store';

export const sessionId = writable(null);

export const csrfTokenStore = writable(null);